
import { Component, h } from 'preact';
import cx from 'classnames';
import { SearchPaginator, PaginationResult } from 'pagination';

interface DashListingsPaginatorProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onPageClicked: (page: number) => any
}

interface DashListingsPaginatorState {
  pagination?: PaginationResult;
}

export class DashListingsPaginator extends Component<DashListingsPaginatorProps, DashListingsPaginatorState> {
  constructor(props) {
    super(props);

    this.state = {
      pagination: new SearchPaginator({
        current: props.currentPage,
        rowsPerPage: props.pageSize,
        totalResult: props.totalItems
      }).getPaginationData()
    };

    // console.log('Pagination range:', this.state.pagination.range);
  }

  componentWillReceiveProps(nextProps: DashListingsPaginatorProps) {
    this.setState({
      pagination: new SearchPaginator({
        current: nextProps.currentPage,
        rowsPerPage: nextProps.pageSize,
        totalResult: nextProps.totalItems
      }).getPaginationData()
    });
  }

  getPreviousPageButton(props: DashListingsPaginatorProps, state: DashListingsPaginatorState) {
    if (state.pagination.previous) {
      return (
        <a onClick={ () => props.onPageClicked(props.currentPage - 1) }
          className="hi-dash-listings__pagination__arrow">
          <i className="fas fa-chevron-left"></i>
        </a>
      );
    } else {
      return (
        <button className="btn hi-dash-listings__pagination__arrow" disabled>
          <i className="fas fa-chevron-left"></i>
        </button>
      );
    }
  }

  getNextPageButton(props: DashListingsPaginatorProps, state: DashListingsPaginatorState) {
    if (state.pagination.next) {
      return (
        <a onClick={ () => props.onPageClicked(props.currentPage + 1) } className="hi-dash-listings__pagination__arrow">
          <i className="fas fa-chevron-right"></i>
        </a>
      );
    } else {
      return (
        <button className="btn hi-dash-listings__pagination__arrow" disabled>
          <i className="fas fa-chevron-right"></i>
        </button>
      );
    }
  }

  getPageNumbers(props: DashListingsPaginatorProps, state: DashListingsPaginatorState) {
    const pagination = state.pagination;
    let range: number[];

    // If there is only one page, "range" is an empty array
    if (pagination.range.length > 0) {
      range = pagination.range;
    } else {
      range = [ 1 ];
    }

    return range.map(page =>
      <a className={ cx( 'hi-dash-listings__pagination__page', {
          'active': props.currentPage === page
        }) }
        onClick={() => props.onPageClicked(page)}
        >
        {page}
      </a>
    );
  }

  render(props: DashListingsPaginatorProps, state: DashListingsPaginatorState) {
    return (
      <div className="hi-dash-listings__pagination">
        { this.getPreviousPageButton(props, state) }
        { this.getPageNumbers(props, state) }
        { this.getNextPageButton(props, state) }
      </div>
    );
  }
}
